module.exports = __webpack_public_path__ + "img/848679_363630_AABBB7_4B4B44-256px.7acfff6e.png";